import {User, UserSchema} from 'vl-common/src/schemas/shared';
import {vlFetch} from './vlFetch';
import Auth, {Hub} from 'aws-amplify';

let latestUserFetch: Promise<User> | undefined = undefined;

async function waitForAuthSession() {
  const session = await Auth.fetchAuthSession();
  const isResetting = sessionStorage.getItem('isPasswordResetting') === 'true';

  if (!session.tokens || isResetting) {
    await new Promise((resolve) => {
      const unsubscribe = Hub.listen('auth', ({payload}) => {
        if (payload.event === 'signedIn') {
          if (sessionStorage.getItem('isPasswordResetting') !== 'true') {
            unsubscribe();
            resolve(undefined);
          }
        }
      });
    });
  }
}

// In "normal" circumstances first_name and last_name are mandatory, but with Axa SSO on a new patient these
// fields are initially empty and have to be requested by the backend
const AxaSSOUser = UserSchema.extend({
  first_name: UserSchema.shape.first_name.nullish().transform(val => val ?? ""),
  last_name: UserSchema.shape.last_name.nullish().transform(val => val ?? "")
});

// Returns the user record, callable before the user is even logged in
export async function getSessionUser() {
  await waitForAuthSession();

  latestUserFetch ||= vlFetch('/users/user/APPUSER', AxaSSOUser);

  return latestUserFetch;
}

// Causes the user record to be refetched, such that getUser() will return the latest user record
export function invalidate() {
  latestUserFetch = undefined;
}

Hub.listen('auth', ({payload}) => {
  if (payload.event === 'signedOut') {
    invalidate();
    console.log('User signed out');
  }
});
